import {
  BorderProps,
  TableCell,
  TableOptions,
  TableRow,
} from '@features/powerpoint';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { textStyles } from './text-styles';

const NO_BORDER: BorderProps = { type: 'none' };

const generateTableCell = (
  cell: TableCell,
  showBottomBorder: boolean
): TableCell => {
  return {
    text: cell.text,
    options: {
      valign: 'middle',
      border: [
        NO_BORDER,
        NO_BORDER,
        showBottomBorder
          ? {
              type: 'solid',
              color: unifiedPlatformColorPalette.inmarketGreen,
              pt: 1,
            }
          : NO_BORDER,
        NO_BORDER,
      ],
      ...cell.options,
    },
  };
};

const generateRow = (cells: TableCell[], showBottomBorder = true): TableRow => {
  return cells.map(cell => {
    return generateTableCell(cell, showBottomBorder);
  });
};

export const generateTable = (
  columnLabels: TableCell[],
  rowTextValues: TableCell[][],
  options?: TableOptions
) => {
  const rows = rowTextValues.map(data => {
    return generateRow(data);
  });

  const tableConfigurations = {
    tableRows: [generateRow(columnLabels), ...rows],
    options: {
      w: 11.81,
      h: 1.22,
      x: 0.76,
      y: 1.64,
      rowH: 0.5,
      fontSize: 8,
      ...options,
      ...textStyles.textDefaults,
    },
  };
  return tableConfigurations;
};

type BuildStyledTableOptions = {
  columns: string[];
  rows: string[][];
  options?: Parameters<typeof generateTable>[2];
};

export const buildStyledTable = (options: BuildStyledTableOptions) => {
  return generateTable(
    options.columns.map(
      (column): Parameters<typeof generateTable>[0][number] => ({
        text: column,
        options: {
          color: unifiedPlatformColorPalette.inmarketGreen,
          bold: true,
        },
      })
    ),
    options.rows.map((row): Parameters<typeof generateTable>[1][number] =>
      row.map(cell => ({ text: cell }))
    ),
    options.options
  );
};
